export const supportChannels = [
  {
    icon: "ri-whatsapp-line",
    title: "WhatsApp",
    description: "Atendimento direto com a nossa equipe durante o horário comercial.",
    value: "54 99654-2326",
    action: "whatsapp",
  },
  {
    icon: "ri-mail-send-line",
    title: "E-mail",
    description: "Envie os detalhes da sua solicitação e respondemos com atenção.",
    value: "vendas@nxhost.com.br",
    action: "email",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Formulário de contato",
    description: "Prefere escrever com calma? Use o nosso formulário e retornamos o contato.",
    value: "Abrir formulário",
    action: "form",
  },
];

export const supportTopics = [
  {
    icon: "ri-server-line",
    title: "Hospedagem e servidores",
    description: "Ajuda com sites, e-mails, VPS e configurações de infraestrutura.",
  },
  {
    icon: "ri-global-line",
    title: "Domínios",
    description: "Registro, renovação, transferência e apontamento de domínios.",
  },
  {
    icon: "ri-layout-masonry-line",
    title: "Sites e lojas virtuais",
    description: "Suporte sobre projetos de sites, lojas virtuais e sistemas.",
  },
  {
    icon: "ri-mail-check-line",
    title: "E-mail profissional",
    description: "Configuração e utilização do e-mail no domínio da sua empresa.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Segurança e SSL",
    description: "Certificados, proteção e boas práticas para manter o seu projeto seguro.",
  },
  {
    icon: "ri-exchange-2-line",
    title: "Migração",
    description: "Ajuda para trazer o seu site ou sistema para a estrutura da NXHOST.",
  },
];

export const supportStatus = [
  { label: "Hospedagem", value: "Operacional", tone: "ok" },
  { label: "Servidores e VPS", value: "Operacional", tone: "ok" },
  { label: "E-mail profissional", value: "Operacional", tone: "ok" },
  { label: "Domínios", value: "Operacional", tone: "ok" },
];

export const supportFaqs = [
  {
    question: "Qual o horário de atendimento?",
    answer:
      "Atendemos de segunda a sexta, em horário comercial. Fale por WhatsApp ou e-mail e a nossa equipe responde o mais rápido possível.",
  },
  {
    question: "Como abro um atendimento?",
    answer:
      "Você pode falar pelo WhatsApp, enviar um e-mail ou usar o formulário de contato. Descreva a sua necessidade e a nossa equipe orienta os próximos passos.",
  },
  {
    question: "O suporte ajuda em migração de site?",
    answer:
      "Sim. Auxiliamos na migração de sites e sistemas para a NXHOST, acompanhando a transição para manter tudo no ar.",
  },
  {
    question: "Existe atendimento para problemas urgentes?",
    answer:
      "Sim. Situações que afetam a disponibilidade do seu projeto têm prioridade. Fale com a nossa equipe para conhecer as condições atuais.",
  },
  {
    question: "Preciso ser cliente para falar com o suporte?",
    answer:
      "Não. Atendemos tanto clientes quanto quem ainda está avaliando as nossas soluções. Conte o que você precisa que ajudamos.",
  },
];